const config = {
  headers: {
    token: localStorage.getItem("token"),
  },
};

export default config;
